var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-wiki-default-template-editor.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { WikiEntryTemplate } from "../db/WikiEntry.js";
import "./x-wiki-editor.js";
import "./x-wiki-view.js";
var XWikiDefaultTemplateEditor = class extends ChemistryLitElement {
  render() {
    return xComponents(html`
      <x-flex padding="lg">
        <x-wiki-editor .entryID=${WikiEntryTemplate.DEFAULT_TEMPLATE_ID}></x-wiki-editor>
      </x-flex>
    `);
  }
};
XWikiDefaultTemplateEditor = __decorateClass([
  customElement("x-wiki-default-template-editor")
], XWikiDefaultTemplateEditor);
export {
  XWikiDefaultTemplateEditor
};
